import { put } from "redux-saga/effects";

import { apiFetch } from "common/utilities";
import { logger } from "common/utilities/logger";
import { activateModal } from "domains/modal/actions";
import { DestinationTypes } from "domains/types";
import {
  fetchTopicsForCollectionFailure,
  fetchTopicsForCollectionSuccess,
  fetchTopicsSuccess,
} from "entities/topics/actions";
import type { FetchTopicsForCollectionAction } from "entities/topics/actionTypes";
import type { Topic } from "entities/topics/types";

export function* fetchTopicsForCollectionSaga({ payload }: FetchTopicsForCollectionAction) {
  const { id, offset, limit } = payload;
  try {
    const topics: Topic[] = yield apiFetch("topic", { queryParams: { collectionId: id, limit, offset, simple: true } });
    yield put(
      fetchTopicsSuccess({
        type: DestinationTypes.COLLECTION,
        topics,
        limit,
        offset,
      }),
    );
    yield put(fetchTopicsForCollectionSuccess({ id }, { offset, numberOfTopicsFetched: topics.length, limit }));
  } catch (error) {
    logger.error("[fetchTopicsForCollectionSaga] Error fetching topics for collection", error);
    yield put(activateModal({ id: "Error" }));
    yield put(fetchTopicsForCollectionFailure({ id }));
  }
}
